import { baseUrl } from './env';
import { Message } from 'element-ui';
import router from '@/router/index.js';

export default async(url = '', data = {}, type = 'GET', method = 'fetch') => {
    type = type.toUpperCase();
    url = baseUrl + url;

    if (type == 'GET') {
        let dataStr = ''; //数据拼接字符串
        Object.keys(data).forEach(key => {
            dataStr += key + '=' + data[key] + '&';
        })

        if (dataStr !== '') {
            dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
            url = url + '?' + dataStr;
        }
    }

    if (window.fetch && method == 'fetch') {
        let requestConfig = {
            credentials: 'include',
            method: type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "API-User-Token": sessionStorage.getItem('token') || ''
            },
            mode: "cors",
            // cache: "force-cache" 请求数据缓存
        }

        if (type == 'POST') {
            Object.defineProperty(requestConfig, 'body', {
                value: JSON.stringify(data)
            })
        }

        try {
            const response = await fetch(url, requestConfig);
            const responseJson = await response.json();

            //在这里可以判断返回状态 token是否过期，如果过期则退出登录，返回登录页面
            if( responseJson.code == 40001 ){ //token以失效

                if (document.getElementsByClassName('el-message').length === 0) {
                    //返回登录窗口
                    Message({
                        type: 'error',
                        message: '您当前登录已过期，请重新登录~',
                        duration: 5000
                    })
                }
                router.replace({
                    path: '/login',
                    name: 'login'
                })
            }else if(responseJson.code === 20001){
                //返回登录窗口
                Message({
                    type: 'error',
                    message: responseJson.message,
                    duration: 5000
                })
            }
            return responseJson
        } catch (error) {
            throw new Error(error)
        }
    } else {
        return new Promise((resolve, reject) => {
            let requestObj;
            if (window.XMLHttpRequest) {
                requestObj = new XMLHttpRequest();
            } else {
                requestObj = new ActiveXObject;
            }

            let sendData = '';
            if (type == 'POST') {
                sendData = JSON.stringify(data);
            }

            requestObj.open(type, url, true);
            requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            requestObj.send(sendData);

            requestObj.onreadystatechange = () => {
                if (requestObj.readyState == 4) {

                    if (requestObj.status == 200) {
                        let obj = requestObj.response

                        if (typeof obj !== 'object') {
                            obj = JSON.parse(obj);
                        }
                        resolve(obj)
                    } else {
                        reject(requestObj)
                    }
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/config/fetch.js